import ReactFroalaEditor from "react-froala-wysiwyg";
import { BUTTON_ATTACH, BUTTON_OPEN_IN_NEW, commandFont, commandFormat, commandOther } from "./config";

export const PRE_SEND_BUTTON = "preSendButton";
export const SEND_BUTTON = "sendReadyButton";
export const MARK_IMPORTANT_BUTTON = "markImportantButton";
export const MAX_HEIGHT_OF_TOOLBAR = 365;
export const MIN_HEIGHT_OF_TOOLBAR = 43;
export const PLACEHOLDER_HEIGHT = 45;
export const COMMANDBUTTONS_EXCLUDE_ATTACHMENT = commandFont.filter((command) => command !== BUTTON_ATTACH);

/** available buttons in the normal mode */
export const TOOLBAR_BUTTONS = {
	moreMisc: {
		buttons: [...COMMANDBUTTONS_EXCLUDE_ATTACHMENT, BUTTON_OPEN_IN_NEW, ...commandFormat, ...commandOther],
		buttonsVisible: 4,
	},

	// placeholder, will be rendered at the very end of the first line in the toolbar
	moreText: {
		align: "right",
		buttons: [SEND_BUTTON, PRE_SEND_BUTTON],
		buttonsVisible: 2,
	},

	// have to specify this so that "paragraphFormat" and other buttons become available
	moreParagraph: {
		buttons: [],
	},
};

/** available buttons in the dialog mode */
export const TOOLBAR_BUTTONS_DIALOG = {
	moreMisc: {
		buttons: [...COMMANDBUTTONS_EXCLUDE_ATTACHMENT, ...commandFormat, ...commandOther],
		buttonsVisible: 18,
	},

	// have to specify this so that "paragraphFormat" and other buttons become available
	moreParagraph: {
		buttons: [],
	},
};

// given the toolbar located in the bottom right corner, handler the popups to avoid mess up
export function openPopupsInRightPane(current: ReactFroalaEditor, action: string): void {
	if (!current) {
		return;
	}

	const editor = current["editor"];
	const editorElement = editor.$box[0] as HTMLElement;
	const rect = editorElement.getBoundingClientRect();
	const { top } = rect;

	switch (action) {
		case "emoticons":
			// 240px is the height of the emojis popup
			editor.popups.show(action, 100, top - 240);
			break;
		case "insertLink":
			// 194px is the height of the link dialog popup
			editor.popups.show("link.insert", 100, top - 194);
			break;
		case "insertTable":
			// 112px is the height of the table popup
			editor.popups.show("table.insert", 100, top - 112);
			break;
		case "textColor":
			// 225px is the height of the picker popup
			// due to the implementation of this particular popup, need extra 127px to adjust
			editor.popups.show("textColor.picker", 100, top + 127 - 225);
			break;
		default:
			break;
	}
};